import React, { useState, useEffect, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function Instruction() {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const modalRef = useRef(null);

    useEffect(() => {
        const hideUntil = localStorage.getItem('instructionHideUntil');
        const hideDate = hideUntil ? new Date(hideUntil) : null;

        if (!hideDate || hideDate <= new Date()) {
            setShow(true);
        }
    }, []);

    const handleDontShow = (days, event) => {
        if (event.target.checked) {
            const futureDate = new Date();
            futureDate.setDate(futureDate.getDate() + days);
            localStorage.setItem('instructionHideUntil', futureDate.toISOString());
        } else {
            localStorage.removeItem('instructionHideUntil');
        }
    };

    // const checkboxContainerStyle = {
    //     backgroundColor: 'rgba(255, 255, 255, 1)',
    //     padding: '10px',
    //     borderRadius: '5px',
    //     margin: '0 10px 10px 10px', // Add margin to keep it off the edges
    // };

    return (
        <>
            <Modal show={show} onHide={handleClose} backdrop="static"
        keyboard={false} size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body><img src='/assets/img/information.jpg' width={'100%'} /></Modal.Body>
                <Modal.Footer>
                        <input type="checkbox" id="sevenDays" onChange={(e) => handleDontShow(7, e)} />
                        <label htmlFor="sevenDays">7일간 안보기</label>
                </Modal.Footer>
            </Modal>
            {/* <div className="modal fade" id="modalLg" tabIndex="-1" aria-labelledby="modalXlLabel" ref={modalRef}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div class="modal-header">

                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <img src='/assets/img/information.jpg' width={'100%'} />


                        </div>
                        <div class="modal-footer">
                            <input type="checkbox" id="sevenDays" onChange={(e) => handleDontShow(7, e)} />
                            <label htmlFor="sevenDays">7일간 안보기</label>
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    );
}

export default Instruction;
